<template>
  <div class="page page-service-list">
    <div class="service-group" v-for="(group,index) in serviceGroupList" :key="group.name">
      <div class="group-name">
        <div class="group-color" :style="{background:getGroupColor(index)}"></div>
        {{ group.name }}
      </div>
      <div class="line"></div>
      <van-row style="padding: 10px 0px;">
        <van-col span="6" v-for="service in group.child" :key="service.id" @click="handleClick(service)">
          <div class="service-item">
            <van-image
                width="50"
                height="50"
                class="service-icon"
                :src="service.iconUrl"
            />
            <div class="service-name">{{ service.name }}</div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<style scoped="scoped">
.page {
  box-sizing: border-box;
  padding: 18px 12px 18px 12px;
}

.service-group {
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  margin-bottom: 12px;
}

.group-name {
  display: flex;
  position: relative;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  padding: 10px 20px;
  align-items: center;
}

.group-color {
  width: 3px;
  height: 16px;
  background: #F83E3E;
  margin-right: 8px;
  border-top-left-radius: 7px;
  border-bottom-right-radius: 7px;
}

.service-item {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  align-items: center;
}

.service-icon {
  max-width: 50px;
  max-height: 50px;
  width: 50px;
  height: 50px;
}

.service-name {
  font-size: 12px;
  margin-top: 10px;
  color: #000000;
}

.line {
  width: 100%;
  height: 1px;
  background: #E2E2E2;
}

</style>
<script>
import {list} from '@/api/service.js'
import nativeApi from '@/utils/native-bridge'
import MIX_LOAD from '@/mixin/mixin-load'

export default {
  name: 'ServiceList',
  components: {},
  mixins: [MIX_LOAD],
  data() {
    return {
      serviceGroupList: [],
      loading: false,
    }
  },
  methods: {
    handleClick(item) {
      if (item.linkUrl) {
        nativeApi.forwardPage({
          uri: item.linkUrl,
          title: item.name
        })
      }
    },
    getGroupColor(index) {
      return ['#F83E3E', '#71ACFF', '#65D4BB'][index % 3];
    },
    loadData() {
      const loading = this.showLoading()
      list().then((rep) => {
        loading.clear();
        const list = rep.data;
        const groupList = [];
        const otherGroup = {name: '其它', child: []};
        list.forEach((service) => {
          const groupName = service.groupName;
          let group = null;
          if (groupName) {
            group = groupList.find((group) => {
              return group.name === groupName
            });
          } else {
            group = otherGroup;
          }
          if (!group) {
            group = {name: groupName, child: []}
            groupList.push(group);
          }
          group.child.push(service);
        })
        if (otherGroup.child.length > 0) {
          groupList.push(otherGroup);
        }
        this.serviceGroupList = groupList;
      }).catch(() => {
        loading.clear();
      })
    }
  },
  created() {
    this.loadData();
  }
}
</script>
